/**
 * COMPREHENSIVE AUTH DEBUGGING UTILITY
 * This will help us find the EXACT reason for logout issues
 */

// Track all token operations
const tokenOperations = [];

// Override localStorage methods to track ALL token operations
const originalSetItem = localStorage.setItem;
const originalRemoveItem = localStorage.removeItem;
const originalClear = localStorage.clear;

localStorage.setItem = function(key, value) {
  const stack = new Error().stack;
  if (key.includes('Token') || key.includes('token') || key.includes('userData') || key.includes('User')) {
    console.log(`%c🔵 localStorage.setItem("${key}")`, 'color: blue; font-weight: bold', {
      value: value?.substring(0, 50) + '...',
      stack: stack.split('\n').slice(2, 5).join('\n')
    });
    tokenOperations.push({
      type: 'SET',
      key,
      timestamp: new Date().toISOString(),
      stack: stack.split('\n').slice(2, 5)
    });
  }
  return originalSetItem.apply(this, arguments);
};

localStorage.removeItem = function(key) {
  const stack = new Error().stack;
  if (key.includes('Token') || key.includes('token') || key.includes('userData') || key.includes('User')) {
    console.log(`%c🔴 localStorage.removeItem("${key}")`, 'color: red; font-weight: bold', {
      stack: stack.split('\n').slice(2, 5).join('\n')
    });
    tokenOperations.push({
      type: 'REMOVE',
      key,
      timestamp: new Date().toISOString(),
      stack: stack.split('\n').slice(2, 5)
    });
  }
  return originalRemoveItem.apply(this, arguments);
};

localStorage.clear = function() {
  const stack = new Error().stack;
  console.log(`%c⚫ localStorage.clear()`, 'color: black; font-weight: bold', {
    stack: stack.split('\n').slice(2, 5).join('\n')
  });
  tokenOperations.push({
    type: 'CLEAR',
    timestamp: new Date().toISOString(),
    stack: stack.split('\n').slice(2, 5)
  });
  return originalClear.apply(this, arguments);
};

// Track all API requests
let requestId = 0;
const apiRequests = [];

// Export debugging functions
window.debugAuth = {
  // Get all token operations
  getTokenOps: () => tokenOperations,
  
  // Get all API requests
  getApiRequests: () => apiRequests,
  
  // Get current auth state
  getCurrentState: () => {
    return {
      authToken: localStorage.getItem('authToken') ? 'EXISTS' : 'MISSING',
      adminToken: localStorage.getItem('adminToken') ? 'EXISTS' : 'MISSING',
      userData: localStorage.getItem('userData') ? 'EXISTS' : 'MISSING',
      authTokenCreatedAt: localStorage.getItem('authTokenCreatedAt'),
      lastUserActivity: sessionStorage.getItem('lastUserActivity'),
      pathname: window.location.pathname
    };
  },
  
  // Find what removed a token
  findTokenRemoval: (tokenName = 'authToken') => {
    const removals = tokenOperations.filter(op => 
      op.type === 'REMOVE' && op.key === tokenName
    );
    console.log(`Found ${removals.length} removals of ${tokenName}:`, removals);
    return removals;
  },
  
  // Check if token exists
  hasToken: () => !!localStorage.getItem('authToken'),
  
  // Get last 10 operations
  recent: () => tokenOperations.slice(-10),
  
  // Clear debug history
  clearHistory: () => {
    tokenOperations.length = 0;
    apiRequests.length = 0;
    console.log('Debug history cleared');
  },
  
  // Track an API request
  trackRequest: (config) => {
    const id = ++requestId;
    const request = {
      id,
      timestamp: new Date().toISOString(),
      method: config.method?.toUpperCase(),
      url: config.url,
      hasAuthHeader: !!config.headers?.Authorization,
      authHeaderPreview: config.headers?.Authorization?.substring(0, 30) + '...'
    };
    apiRequests.push(request);
    console.log(`%c📤 API REQUEST #${id}`, 'color: green; font-weight: bold', request);
    return id;
  },
  
  // Track an API response
  trackResponse: (id, response) => {
    const request = apiRequests.find(r => r.id === id);
    if (request) {
      request.status = response.status;
      request.responseTime = new Date().toISOString();
      console.log(`%c📥 API RESPONSE #${id}`, 'color: blue; font-weight: bold', {
        status: response.status,
        url: request.url
      });
    }
  },
  
  // Track an API error
  trackError: (id, error) => {
    const request = apiRequests.find(r => r.id === id);
    if (request) {
      request.error = error.message;
      request.status = error.response?.status;
      request.errorTime = new Date().toISOString();
      console.log(`%c❌ API ERROR #${id}`, 'color: red; font-weight: bold', {
        status: error.response?.status,
        url: request.url,
        error: error.message
      });
    }
  }
};

// Log initial state
console.log('%c🔍 AUTH DEBUGGER INITIALIZED', 'color: purple; font-weight: bold; font-size: 14px');
console.log('Use window.debugAuth to inspect auth operations');
console.log('Commands:', {
  'debugAuth.getCurrentState()': 'Get current auth state',
  'debugAuth.getTokenOps()': 'Get all token operations',
  'debugAuth.findTokenRemoval()': 'Find what removed the token',
  'debugAuth.recent()': 'Get last 10 operations',
  'debugAuth.getApiRequests()': 'Get all API requests'
});

export default window.debugAuth;
